export default "__VITE_ASSET__7c736d35__"